import { render, staticRenderFns } from "./IconBus.vue?vue&type=template&id=c934297a"
import script from "./IconBus.vue?vue&type=script&lang=js"
export * from "./IconBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports